import { render, staticRenderFns } from "./Horas.vue?vue&type=template&id=5b228e8e&scoped=true&"
import script from "./Horas.vue?vue&type=script&lang=js&"
export * from "./Horas.vue?vue&type=script&lang=js&"
import style0 from "./Horas.vue?vue&type=style&index=0&id=5b228e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b228e8e",
  null
  
)

export default component.exports